import React, { useState, useEffect } from 'react'

// Partials
import Btn from 'views/shared/partials/btn'
import Dropdown from 'views/shared/partials/dropdown'
import { Table, TR, TD } from 'views/shared/partials/table'
import Loader from 'views/shared/partials/loader'
import Link from 'views/shared/partials/link'

// Utils
import { openModal } from 'utils/modals';

// Sections
import Breadcrumbs from 'views/admin/sections/breadcrumbs'

// Services
import companyServices from 'services/company'

const CompanyPaymentTypes = (props) => {
	const [data, setData] = useState(false);

	const getPaymentTypes = () => {
		setData(false);
		companyServices.listPaymentTypes({ page: 1, per_page: 9999 }).then((payload) => {
			setData(payload)
		})
	}

	const deletePaymentType = (type) => {
		openModal(
			'confirm',
			{
				message: type.payment_type.name + ' isimli ödeme türünü silmek istediğinizden emin misiniz?',
				onConfirm: () => {
					setData(false);
					companyServices.deletePaymentType(type.id).then(() => {
						getPaymentTypes();
					}).catch(() => {});
				}
			}
		)
	}

	useEffect(() => {
		getPaymentTypes();
	}, [])

	return (
		<main className="page company-payment-types">
			<Breadcrumbs />
			<section className="portlet section types-list">
				<div className="portlet-header">
					<strong className="portlet-title">Ödeme Ayarları</strong>

					<div className="header-controls">
						<Btn
							white small wide
							onClick={() => { openModal('company-payment-type', { onSuccess: getPaymentTypes }); }}
							icon="plus">
							Ödeme Yöntemi Oluştur
						</Btn>
						<Btn
							white small wide
							onClick={() => { openModal('company-payment-type-order', { onSuccess: getPaymentTypes }); }}
							icon="list">
							Sıralamayı Değiştir
						</Btn>
					</div>
				</div>

				<div className="portlet-section bottom loader-container">
					<Loader loading={!data} />

					{(data && data.paymentTypes) &&
						<Table 
							emptyMessage="Hiç ödeme bulunmuyor."
							className="list-table"
							heading={
								<React.Fragment>
									<th>Ödeme Türü</th>
									<th>API İsmi</th>
									<th>AMEX</th>
									<th>Taksitler</th>
									<th></th>
								</React.Fragment>
							}>
							
							{data.paymentTypes.map((type, nth) => (
								<TR key={nth} mobileTitle={type.payment_type.name}>
									<TD hideMobile>
										{type.payment_type.name}
										
									</TD>
									<TD mobileTitle="API İsmi">
										{type.api_name}
									</TD>
									<TD mobileTitle="AMEX">
										{type.amex ? 'Evet' : 'Hayır'}
									</TD>
									<TD mobileTitle="Taksitler" className="mobile-full">
										{type.installment_info}
									</TD>
									<TD className="controls">
										<Dropdown
											text="İşlemler"
											icon="list">
											<Link
												href="settings.companyPaymentTypeDetail"
												params={{id: type.id}}>
												Düzenle
											</Link>
											<button
												className="error"
												onClick={() => { deletePaymentType(type); }}>
												Sil
											</button>
										</Dropdown>
									</TD>
								</TR>
							))}
						</Table>
					}
				</div>
			</section>
		</main>
	)
}

export default CompanyPaymentTypes